import { render, staticRenderFns } from "./ClientDetailsProxy.vue?vue&type=template&id=254d0f88&"
import script from "./ClientDetailsProxy.vue?vue&type=script&lang=ts&"
export * from "./ClientDetailsProxy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports